import { render } from "./SetDiscountGratuityModal.vue?vue&type=template&id=2d1f708f&scoped=true"
import script from "./SetDiscountGratuityModal.vue?vue&type=script&lang=js"
export * from "./SetDiscountGratuityModal.vue?vue&type=script&lang=js"

import "./SetDiscountGratuityModal.vue?vue&type=style&index=0&id=2d1f708f&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1f708f"]])

export default __exports__